import { useMemo } from "react";
import { useUserAspectState } from "./state";
import { UserAspect } from "./aspect-types";

export const TOKEN_REFRESH_CHECK_INTERVAL = 5 * 60 * 1000;

export function intercomLogout() {
  //@ts-expect-error
  if (typeof Intercom === "function") {
    try {
      //@ts-expect-error
      Intercom("shutdown");
    } catch (err) {
      console.error(err);
    }
  }
}

export function useUserAspect(): UserAspect | undefined {
  const [state, dispatch] = useUserAspectState();

  return useMemo(() => {
    if (!state) {
      return undefined;
    } else if (state.tag === "logged-in-user") {
      return {
        user: "logged-in-user",
        authToken: state.authToken,
        dispatch: dispatch,
        userData: state.userData,
        userProfileSf: state.userProfileSf,
      };
    } else {
      return {
        user: "anonymous-user",
        authToken: state.authToken,
        dispatch: dispatch,
        userData: undefined,
      };
    }
  }, [JSON.stringify(state), dispatch]);
}
